import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_CREATE_SELLABLE_ITEM = createRequestTypes('ENTITIES_CREATE_SELLABLE_ITEM')
export const ENTITIES_UPDATE_SELLABLE_ITEM = createRequestTypes('ENTITIES_UPDATE_SELLABLE_ITEM')
export const ENTITIES_DELETE_SELLABLE_ITEM = createRequestTypes('ENTITIES_DELETE_SELLABLE_ITEM')

export const createSellableItem = {
  request: () => action(ENTITIES_CREATE_SELLABLE_ITEM.REQUEST),
  success: (response, args) => action(ENTITIES_CREATE_SELLABLE_ITEM.SUCCESS, { args, response }),
  failure: (error, args) => action(ENTITIES_CREATE_SELLABLE_ITEM.FAILURE, { args, error }),
}

export const updateSellableItem = {
  request: () => action(ENTITIES_UPDATE_SELLABLE_ITEM.REQUEST),
  success: (response, args) => action(ENTITIES_UPDATE_SELLABLE_ITEM.SUCCESS, { args, response }),
  failure: (error, args) => action(ENTITIES_UPDATE_SELLABLE_ITEM.FAILURE, { args, error }),
}

export const deleteSellableItem = {
  request: () => action(ENTITIES_DELETE_SELLABLE_ITEM.REQUEST),
  success: (response) => action(ENTITIES_DELETE_SELLABLE_ITEM.SUCCESS, { response }),
  failure: (error) => action(ENTITIES_DELETE_SELLABLE_ITEM.FAILURE, { error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/sellable-item/sellable-item-actions.js
 **/